export function getRandomIndex(max: number): number {
  return Math.floor(Math.random() * max);
}

export function generateRandomName(): string {
  const adjective = ADJECTIVES[getRandomIndex(ADJECTIVES.length)];
  const noun = NOUNS[getRandomIndex(NOUNS.length)];
  return `${adjective}-${noun}`;
}

export const ADJECTIVES = [
  'blue',
  'bright',
  'calm',
  'clear',
  'cool',
  'crisp',
  'clean',
  'kind',
  'fair',
  'bold',
  'brave',
  'swift',
  'quick',
  'light',
  'soft',
  'warm',
  'fresh',
  'pure',
  'mild',
  'sharp',
  'smooth',
  'steady',
  'proud',
  'sunny',
  'happy',
  'quiet',
  'wise',
  'green',
  'golden',
  'silver',
  'vivid',
  'neat',
  'cozy',
  'simple',
  'true',
  'keen',
  'playful',
  'lucky',
  'noble',
  'honest',
  'gentle',
  'glowing',
  'lively',
  'open',
  'friendly',
  'eager',
  'smart',
  'safe',
  'pure',
  'soft',
  'light',
  'warm',
  'happy',
  'quiet',
  'wise',
  'bold',
  'swift',
  'fresh',
  'kind',
  'calm',
  'clear',
  'bright',
  'gentle',
  'lucky',
  'noble',
  'true',
  'keen',
  'cozy',
  'simple',
  'honest',
  'lively',
  'open',
  'eager',
  'smart',
  'safe',
  'steady',
  'smooth',
  'proud',
  'sunny',
  'fresh',
  'kind',
  'quiet',
  'glowing',
  'friendly',
  'playful',
  'vivid',
  'neat',
  'cool',
  'clean',
  'fair',

  'soft',
  'merry',
  'quick',
  'calm',
  'kind',
  'bright',
  'pure',
  'open',
  'brisk',
  'clear',
  'fresh',
  'happy',
  'light',
  'warm',
  'safe',
  'neat',
  'sweet',
  'true',
  'keen',
  'wise',
  'brave',
  'bold',
  'sunny',
  'fair',
  'gentle',
  'lucky',
  'steady',
  'simple',
  'clean',
  'calm',
  'cool',
  'glad',
  'proud',
  'fresh',
  'open',
  'kind',
  'soft',
  'bright',
  'clear',
  'mild',
  'swift',
  'quiet',
  'honest',
  'noble',
  'cozy',
  'lively',
  'smooth',
  'eager',
  'smart',
  'friendly',

  'playful',
  'glowing',
  'vivid',
  'golden',
  'silver',
  'green',
  'blue',
  'calm',
  'clear',
  'bright',
  'pure',
  'fresh',
  'warm',
  'soft',
  'quick',
  'swift',
  'gentle',
  'steady',
  'safe',
  'happy',
  'quiet',
  'wise',
  'kind',
  'fair',
  'clean',
  'cool',
  'neat',
  'open',
  'true',
  'keen',
  'brisk',
  'merry',
  'sunny',
  'bold',
  'brave',
  'lucky',
  'simple',
  'honest',
  'noble',
  'proud',
];

export const NOUNS = [
  'fox',
  'wolf',
  'bear',
  'owl',
  'hawk',
  'eagle',
  'deer',
  'lynx',
  'otter',
  'seal',
  'dolphin',
  'whale',
  'panda',
  'tiger',
  'lion',
  'rabbit',
  'squirrel',
  'badger',
  'beaver',
  'horse',
  'falcon',
  'crane',
  'swan',
  'heron',
  'robin',
  'sparrow',
  'turtle',
  'gecko',
  'frog',
  'koi',
  'salmon',
  'trout',
  'river',
  'ocean',
  'lake',
  'stream',
  'forest',
  'grove',
  'meadow',
  'hill',
  'valley',
  'ridge',
  'peak',
  'cloud',
  'breeze',
  'flame',
  'ember',
  'spark',
  'stone',
  'pebble',
  'leaf',
  'branch',
  'root',
  'seed',
  'bloom',
  'pine',
  'oak',
  'maple',
  'cedar',
  'willow',
  'moss',
  'fern',
  'ivy',
  'field',
  'path',
  'trail',
  'bridge',
  'tower',
  'beacon',
  'harbor',
  'anchor',
  'sail',
  'shell',
  'coral',
  'dune',
  'island',
  'shore',
  'wave',
  'tide',
  'star',
  'comet',
  'moon',
  'sun',
  'orbit',
  'glow',
  'echo',
  'pulse',
  'rhythm',
  'horizon',
  'compass',

  'otter',
  'badger',
  'marten',
  'stoat',
  'ferret',
  'vole',
  'mouse',
  'hare',
  'elk',
  'moose',
  'bison',
  'yak',
  'goat',
  'sheep',
  'lamb',
  'calf',
  'foal',
  'colt',
  'pony',
  'donkey',
  'ibex',
  'oryx',
  'gazelle',
  'antelope',
  'lemur',
  'koala',
  'wombat',
  'wallaby',
  'quokka',
  'sloth',
  'manatee',
  'narwhal',
  'orca',
  'beluga',
  'penguin',
  'puffin',
  'auk',
  'loon',
  'gull',
  'tern',
  'albatross',
  'pelican',
  'egret',
  'ibis',
  'stork',
  'viper',
  'adder',
  'python',
  'anole',
  'skink',

  'lagoon',
  'bay',
  'fjord',
  'delta',
  'estuary',
  'reef',
  'shoal',
  'cove',
  'inlet',
  'spring',
  'creek',
  'brook',
  'pond',
  'marsh',
  'fen',
  'bog',
  'moor',
  'plain',
  'steppe',
  'prairie',
  'plateau',
  'mesa',
  'butte',
  'canyon',
  'cliff',
  'bluff',
  'slope',
  'summit',
  'pass',
  'range',
  'grove',
  'copse',
  'thicket',
  'canopy',
  'glade',
  'clearing',
  'trail',
  'track',
  'route',
  'way',
  'signal',
  'marker',
  'token',
  'symbol',
  'icon',
  'glyph',
  'badge',
  'crest',
  'emblem',
  'seal',
];
